var _rect, _rect2, _rect3, _rect4, _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPositionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.94637,
    y: 13.3199,
    width: 1.14502,
    height: 2.71133,
    fill: "#003863",
    stroke: "#003863",
    strokeWidth: 0.381674
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.94637,
    y: 0.8951,
    width: 1.14502,
    height: 2.71133,
    fill: "#003863",
    stroke: "#003863",
    strokeWidth: 0.381674
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.74797,
    y: 7.88436,
    width: 1.15823,
    height: 2.67172,
    transform: "rotate(90 3.74797 7.88436)",
    fill: "#003863",
    stroke: "#003863",
    strokeWidth: 0.381674
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.725,
    y: 7.88436,
    width: 1.15823,
    height: 2.67172,
    transform: "rotate(90 16.725 7.88436)",
    fill: "#003863",
    stroke: "#003863",
    strokeWidth: 0.381674
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6717 8.46281C13.6717 11.3725 11.3556 13.7144 8.51906 13.7144C5.68257 13.7144 3.36646 11.3725 3.36646 8.46281C3.36646 5.55312 5.68257 3.21118 8.51906 3.21118C11.3556 3.21118 13.6717 5.55312 13.6717 8.46281Z",
    stroke: "#003863",
    strokeWidth: 1.14502,
    fill: "#FFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.51889,
    cy: 8.46305,
    rx: 2.67172,
    ry: 2.71793,
    fill: "#003863"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionsIcon);
export default __webpack_public_path__ + "static/media/positionsIcon.14be4298a174c2f7c0abb6101709f672.svg";
export { ForwardRef as ReactComponent };